import 'Handlebars';
import { initDisclosure } from '@fr/disclosure';
import formValidation from '@fr/form-validation';
import { getParam } from '@fr/query-param';
import signaturePadModule from '@fr/signature-pad';

var page = {

  /**
   * The esignature document identifier.
   * @type {String}
   */
  documentId: '',

  /**
   * The encrypted case id to identify the
   * esignature  document id.   *
   * @type {String}
   */
  encryptedCaseId: getParam('caseid'),

  /**
   * The page handlebars template source selector.
   * @type {String}
   */
  templateSourceSelector: '#e-signature-template',

  /**
   * Template compiled into Javascript.
   * @type {Object}
   */
  jsTemplate: null,

  /**
   * The selector to the placeholder into which the page handlebars template
   * should be rendered.
   * @type {String}
   */
  placeholderSelector: '#e-signature',

  /**
   * The placeholder into which the page handlebars template should be rendered.
   * jQuery object.
   * @type {Object}
   */
  $placeholder: null,

  /**
   * Error message for baq request error type.
   * @type {String}
   */
  badRequestMessage: '',

  /**
   * Error message for any other kind of error type.
   * @type {String}
   */
  unexpectedExceptionMessage: '',

  apiURL: null,

  cmaeSignatureURL: null,

  /**
   * Flag for type of document.
   */
  getIsLegalCaseNoa: function(){

    var self = this;

    // Call API to fetch the document type (NoA/PoA).
    return $.ajax({
      type: 'GET',
      url: `${ this.cmaeSignatureURL }/${ this.encryptedCaseId }/isNoaOrPoa`,
      contentType: 'text/plain',
      success: function (data, textStatus, jqXHR) {

        if(jqXHR.responseText === 'NoA') {
          self.isLegalCaseNoa = true;
        }
        else if(jqXHR.responseText === 'PoA') {
          self.isLegalCaseNoa = false;
        }
        else {
          self.isUnknownDocumentType = true;
        }

      },
      error: function (data) {
        console.log(`Can't get document type!`);
        self.isUnknownDocumentType = true;
      }
    });

  },


  /**
   * Get document id by encrypted case id
   */
  getDocumentIdByEncryptedCaseId: function () {

    var self = this;
    var $template = $(this.templateSourceSelector);

    // Get url from template
    this.cmaeSignatureURL = $template.attr('data-cma-esignature-url');

    // Call API to fetch the document id
    $.ajax({
      type: 'GET',
      url: this.cmaeSignatureURL + '/' + this.encryptedCaseId,
      contentType: 'application/json',
      success: function (data, textStatus, xhr) {

        // Set document id by case id.
        if (data.id !== 'undefined') {
          self.documentId = data.id;
          self.getDocumentInformation();
        }
      },
      error: function (data) {
        // Show message, that document is signed.
        if (data.status === 403) {
          data.isCompleted = true;
          self.renderTemplate(data);
          return;
        }
      }
    });
  },

  /**
   * Gets the information about the signature status regarding.
   */
  getDocumentInformation: function () {

    var self = this;

    // Call API to fetch the passengers list...
    $.ajax({
      url: this.apiURL + '/documents/' + this.documentId,
      type: 'GET',
      success: function (data, textStatus, xhr) {

        // Once we got the document information, we need an extra call to get
        // the type of document, and only then we can render the template.
        self.getIsLegalCaseNoa().complete(function(){

          // Provides these flags to be reachable by the template.
          data.isLegalCaseNoa = self.isLegalCaseNoa;
          data.isUnknownDocumentType = self.isUnknownDocumentType;

          self.renderTemplate(data);

        });

      }
    });
  },

  /**
   * Updates the given passenger's address.
   * @param  {String} passengerId Passenger identifier.
   */
  persistPassengerAddress: function (passengerId, successCallback) {

    var self = this,
      $form = $('form[data-passenger-id="' + passengerId + '"]'),
      address = {
        street: $form.find('[name="street"]').val(),
        postalCode: $form.find('[name="postalCode"]').val(),
        city: $form.find('[name="city"]').val(),
        country: $form.find('[name="country"]').val()
      },
      data = {
        id: passengerId,
        address: address
      },
      $errorPlaceholder = this.$placeholder.find('[data-passenger-id="' + passengerId + '"].js-error-placeholder');

    // Resets error.
    if ($errorPlaceholder.hasClass('box--alert')) {
      $errorPlaceholder.removeClass('box box--alert  mg-Bhg').text('');
    }

    // Updates address information.
    $.ajax({
      url: this.apiURL + '/documents/' + this.documentId + '/passengers/' + passengerId,
      type: 'PUT',
      data: JSON.stringify(data),
      contentType: 'application/json',
      success: function (data, textStatus, xhr) {
        successCallback();
      },
      error: function (xhr, textStatus, errorThrown) {
        $errorPlaceholder.addClass('box box--alert  mg-Bhg');
        $errorPlaceholder.text(self.unexpectedExceptionMessage);
        throw new Error(xhr.responseText);
      }
    });
  },

  /**
   * Persists the given passenger signature.
   * @param  {String} passengerId The given passenger.
   * @param  {String} signature API ready formatted signature.
   */
  persistPassengerSignature: function (passengerId, signature, successCallback) {

    var self = this,
      $errorPlaceholder = this.$placeholder.find('[data-passenger-id="' + passengerId + '"].js-error-placeholder');

    // Resets error.
    if ($errorPlaceholder.hasClass('box--alert')) {
      $errorPlaceholder.removeClass('box box--alert  mg-Bhg').text('');
    }

    // Persists the signature.
    $.ajax({
      url: this.apiURL + '/documents/' + this.documentId + '/passengers/' + passengerId + '/signatures',
      data: JSON.stringify(signature),
      type: 'POST',
      contentType: 'application/json',
      success: function (data, textStatus, xhr) {

        // Tracks the signature in GA.
        if(dataLayer) {
          dataLayer.push({
            'event': 'gaEvent',
            'eventCategory': 'e-signature',
            'eventAction': 'landingpage',
            'eventLabel': 'signed'
          });
        }

        window.optimizely = window.optimizely || [];
        window.optimizely.push({
          type: "event",
          eventName: 'Goal Signature signed LP'
        });

        successCallback();

      },
      error: function (xhr) {
        $errorPlaceholder.addClass('box box--alert  mg-Bhg');
        if (xhr.status === 400) {
          $errorPlaceholder.text(self.badRequestMessage);
          self.scrollToError();
        }
        else {
          $errorPlaceholder.text(self.unexpectedExceptionMessage);
          throw new Error(xhr.responseText);
        }
      }
    });

  },

  /**
   * Callback bound behind the `Use` button of the signature-pad.
   *
   * 1. param  {Object} signaturePad The signature-pad canvas.
   *    param  {Object} button       The `Use` button DOM element.
   */
  useButtonCallback: function () {

    var self = this,
      updatePage = function () {
        // Refreshes the signature document information.
        self.getDocumentInformation();
      };

    /* [1] */
    return function (signaturePad, button) {

      var signature,
        passengerId = button.getAttribute('data-passenger-id'),
        $addressForm = self.$placeholder.find('form[data-passenger-id="' + passengerId + '"]'),
        isValid = false;

      // If we come from the contact person signature pad, we do not need check
      // on the address, we have it already.
      if ($addressForm.length === 0) {
        isValid = true;
      }
      // For extra passenger we validate the address form.
      else if ($addressForm.length === 1) {
        isValid = formValidation.validateFields($addressForm);
      }

      // Signature is required !
      if (isValid && !signaturePad.isEmpty()) {

        const date   = (new Date()).toString(),
              regGMT = /(GMT[\+\-][0-9]{4})/g;

        signature = {
          'base64EncodedSignature': signaturePad.toDataURL('image/svg+xml').split(",")[1],
          'timeZone': date.search(regGMT) > -1 ? date.match(regGMT).join() : null
        };

        try {
          // For the main contact we just need to sign.
          if ($addressForm.length === 0) {
            self.persistPassengerSignature(passengerId, signature, updatePage);
          }
          // For extra passengers we need to first save address information and
          // then only sign the document.
          else if ($addressForm.length === 1) {
            self.persistPassengerAddress(passengerId, function () {
              // Refreshes the signature document information.
              self.persistPassengerSignature(passengerId, signature, updatePage);
            });
          }
        }
        catch (error) {
          self.scrollToError();
          console.log(error);
        }

      }

    };

  },

  /**
   * Scrolls to the active error on the page.
   */
  scrollToError: function () {
    $("html, body").animate({scrollTop: $('.js-error-placeholder.box--alert').offset().top - 5}, 800);
  },

  /**
   * Replace the template placeholder with the rendered template.
   * @param  {Object} data Context object fetched from the esignature API.
   */
  renderTemplate: function (data) {

    // Handlebars magic rendering.
    this.$placeholder.html(this.jsTemplate(data));

    // Fires the signature pad.
    this.$placeholder.find('.signature-pad').each((index, element) => {
      signaturePadModule.init(element, null, this.useButtonCallback());
    });

    // Fires the custom select dropdowns.
    this.$placeholder.find('.custom-select').customSelect();

    initDisclosure(document.querySelector('.js-disclosure-control'));
  },

  /**
   * Page initializer.
   */
  init: function () {

    var $template = $(this.templateSourceSelector),
      source = $template.html();

    this.$placeholder = $(this.placeholderSelector);
    this.badRequestMessage = $template.attr('data-error-bad-request');
    this.unexpectedExceptionMessage = $template.attr('data-error-unexpected');
    this.apiURL = $template.attr('data-api-url');

    if (this.$placeholder.length > 0 && source) {

      // This gives a bit of air so that the footer is not interfering too much
      // visually with the screen.
      this.$placeholder.css('marginBottom', '50px');

      // Compiles the template into JavaScript.
      this.jsTemplate = Handlebars.compile(source);

      // Fetches document id by encrypted case id.
      this.getDocumentIdByEncryptedCaseId();

    }


  }


};


// On document ready
$(function () {
  page.init();
});
